import React from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { MessageCircle, Megaphone, Package } from "lucide-react";
import { useApiQuery } from "../lib/useApiQuery";
import { Loader, EmptyState } from "../components/Loader";
import { Verified } from "../components/Verified";

export default function Chats() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { data: convs = [], isLoading } = useApiQuery(["conversations"], "/messages/conversations", { staleTime: 10000 });

  const onTap = (item) => {
    // Optimistically clear this conversation's unread badge when opened.
    if (item.unread_count > 0 && !item.user_id.startsWith("broadcast:")) {
      qc.setQueryData(["conversations"], (prev) =>
        Array.isArray(prev)
          ? prev.map((c) =>
              c.user_id === item.user_id && (c.order_id || "") === (item.order_id || "")
                ? { ...c, unread_count: 0 }
                : c)
          : prev);
    }
    if (item.user_id.startsWith("broadcast:")) return navigate("/notifications");
    if (item.order_id) return navigate(`/chat/order/${item.order_id}`);
    navigate(`/chat/${item.user_id}?name=${encodeURIComponent(item.name)}`);
  };

  if (isLoading) return <Loader />;

  return (
    <div className="animate-fade-in-up max-w-2xl mx-auto">
      <h1 className="text-2xl font-black text-[#161629] mb-4">الرسائل</h1>
      {convs.length === 0 ? (
        <EmptyState icon={MessageCircle} title="لا توجد محادثات بعد" />
      ) : (
        <div className="space-y-2.5">
          {convs.map((item) => {
            const isBroadcast = item.user_id.startsWith("broadcast:");
            return (
              <button key={`${item.user_id}::${item.order_id || ""}`} data-testid={`chat-row-${item.user_id}`} onClick={() => onTap(item)} className={`w-full flex items-center gap-3 p-3.5 rounded-2xl border text-start ${isBroadcast ? "bg-[#FFF4ED] border-[#FF6B35]" : "bg-white border-[#E8EAF2]"} hover:brand-shadow-sm transition-shadow`}>
                <div className="relative shrink-0">
                  {item.picture ? <img src={item.picture} alt="" className="w-13 h-13 rounded-2xl w-[52px] h-[52px] object-cover" /> : <div className={`w-[52px] h-[52px] rounded-2xl flex items-center justify-center text-white font-black text-xl ${item.is_admin ? "bg-[#FF6B35]" : "bg-[#FF3D5A]"}`}>{item.name?.[0] || "?"}</div>}
                  {item.unread_count > 0 && <span className="absolute -top-1 -end-1 min-w-[20px] h-5 px-1 rounded-full bg-[#FF3D5A] text-white text-[10px] font-black flex items-center justify-center border-2 border-white">{item.unread_count > 99 ? "99+" : item.unread_count}</span>}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-1.5">
                    {isBroadcast && <Megaphone size={14} className="text-[#FF6B35]" />}
                    {item.order_id && <Package size={13} className="text-[#FF3D5A]" />}
                    <span className="font-black text-[#161629] truncate">{item.name}</span>
                    {item.verified && <Verified size={13} />}
                  </div>
                  {item.order_id && item.order_product_name && <p className="text-[10px] text-[#FF3D5A] font-black truncate mt-0.5">📦 {item.order_product_name}</p>}
                  <p className={`text-sm truncate mt-0.5 ${item.unread_count > 0 ? "text-[#161629] font-bold" : "text-[#6B7280]"}`}>{item.last_message}</p>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
